<template>
  <div
    v-for="(value, index) in rowData"
    :key="index"
    :class="[
      'at-a-glance-table__header',
      `column-${fromReport ? '' : index}`,
      firstRow ? 'mid-blue' : 'light-blue',
      !hasHighlight ? 'no-highlight' : '',
    ]"
  >
    {{
      (parseInt(index) === rowData.length - 1 && !firstRow) ||
      (parseInt(index) === rowData.length - 1 && !hasHighlight)
        ? ''
        : value
    }}
  </div>
</template>

<script>
  export default {
    name: 'AtAGlanceIndicatorTableHeaderRow',
    props: {
      rowData: {
        type: Object,
        required: true,
      },
      firstRow: {
        type: Boolean,
        default: false,
      },
      hasHighlight: {
        type: Boolean,
        default: false,
      },
      fromReport: {
        type: Boolean,
        default: false,
      }
    },
  };
</script>

<style lang="scss" scoped>
  .at-a-glance-table {
    &__header {
      text-align: center;
      font-size: 14px;
      color: var(--itr-white);
      font-weight: bold;
      line-height: 14px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 1px solid var(--itr-tr-grey);
      border-width: thin;
      font-family: 'Open Sans', sans-serif !important;
    }
    &__header.mid-blue {
      background: var(--itr-blue-mid);
    }
    &__header.mid-blue.column-0 {
      border-top-left-radius: 8px;
    }
    &__header.mid-blue.column-7 {
      border-top-right-radius: 8px;
    }
    &__header.light-blue {
      background: var(--itr-blue-light);
    }
  }
</style>
